import { renderField } from "components/offerings/TelegramForm/steps/FormStep";
import cls from "classnames";

export default function InputGroup({
  label,
  fields,
  className,
  showHint = false,
  ...otherParentProps
}) {
  const { formErrors, formData } = otherParentProps;
  let errors = getErrors(formErrors, fields);

  const shownHint = errorExists(errors)
    ? null
    : showHint
    ? getHintFromFormData(formData)
    : null;

  return (
    <div className="flex flex-col items-start justify-start gap-2 my-2 w-full max-w-[420px]">
      {label && (
        <label htmlFor="input" className="font-semibold text-sm text-[#16191B]">
          {label}
        </label>
      )}
      <div
        className={cls(
          "flex flex-row items-start gap-2 w-full max-w-[420px] -mt-2",
          className
        )}
      >
        {fields.map((field, idx) => {
          let component = renderField(field, otherParentProps, {
            _hideError: true,
          });

          return (
            <div className="flex-1" key={idx}>
              {component}
            </div>
          );
        })}
      </div>
      {shownHint && (
        <span className="text-sm w-full max-w-[420px] text-[#898989]">
          {shownHint}
        </span>
      )}
      {errors &&
        errors.map((error, idx) => (
          <span className="text-[#EE0000] font-semibold text-sm w-full max-w-[420px]">
            {error}
          </span>
        ))}
    </div>
  );
}

function getErrors(formErrors, fields) {
  let errors = [];
  fields.forEach((field) => {
    if (formErrors[field.name]) {
      errors.push(formErrors[field.name]);
    }
  });

  return errors;
}

function errorExists(errors) {
  return errors && errors.length > 0;
}

function checkNoun(interval, duration) {
  if (Math.abs(interval) > 1) {
    return duration?.toLowerCase();
  } else {
    return duration?.substring(0, duration.length - 1).toLowerCase();
  }
}

function getHintFromFormData(formData) {
  let hint =
    formData?.duration?.value === "lifetime"
      ? "Members will get lifetime access in this plan"
      : formData?.interval
      ? `Members will receive reminders after every ${Number(
          formData?.interval
        )} ${checkNoun(
          formData?.interval,
          formData?.duration?.value
        )} for renewing the plan`
      : null;

  return hint;
}
